import { MinutePageHeader } from 'components/minute/layout/MinutePageHeader';
import { MinutePageTitle } from 'components/minute/layout/MinutePageTitle';
import { MyAccountPageContent } from 'components/site/pages/MyAccountPageContent';
import CSS from 'csstype';
import { MinuteWhiteBg } from 'pages/minute/shared/MinuteWhiteBg';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { GlobalContext } from 'session/state/context';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components';

export interface IProps {
    style?: CSS.Properties;
    className?: string;
}

export const MyAccountPage = (): JSX.Element => {
    const { state } = useContext(GlobalContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (state.loggedUserChecked && !state.loggedUser) {
            navigate('/admin');
        }
    }, [state.loggedUserChecked, state.loggedUser]);

    if (!state.loggedUser || !state.loggedUserChecked) {
        return null;
    }

    return (
        <S_MyAccountPage>
            <S_Center>
                <MinutePageHeader />
                <MinutePageTitle title={Localization.MY_ACCOUNT}>
                    {Localization.MY_ACCOUNT_DESC}
                </MinutePageTitle>
                <S_Row>
                    <S_Mid>
                        <MyAccountPageContent />
                    </S_Mid>
                </S_Row>
            </S_Center>
            <MinuteWhiteBg />
        </S_MyAccountPage>
    );
};

const S_MyAccountPage = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    align-items: center;
    @media only screen and (min-width: 1260px) {
        min-width: 1260px;
    }
`;

const S_Center = styled.div`
    display: flex;
    margin: 40px 0 0 0;
    flex-direction: column;
    z-index: 1;
    @media only screen and (min-width: 1260px) {
        width: 1260px;
    }
`;

const S_Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const S_Mid = styled.div`
    border-radius: 7px;
    background: #efefef;
    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.1);
    @media only screen and (min-width: 1260px) {
        width: 400px;
    }
`;
